<div class="inner-page-wrapper py-24 md:py-40">
    <div class="bg-grey-100 grid grid-cols-1 md:grid-cols-2">
        <div class="relative">
            @if (firstBadge(); as badge) {
                @let firstBadgeWithFootnote = badge | footnotes;
                <ui-m040-c030-badge class="absolute top-16 right-16 z-10" type="accent">
                    <span [innerHTML]="firstBadgeWithFootnote()"></span>
                </ui-m040-c030-badge>
            }
            @if (secondBadge(); as badge) {
                <ui-m040-c030-badge class="absolute top-16 left-16 z-10" type="white">{{ badge }}</ui-m040-c030-badge>
            }
            <ui-m000-c010-image
                class="block h-full overflow-hidden"
                [classList]="`${imageCSS()} h-full w-full aspect-[608/342] object-cover`"
                [image]="{
                    image: image().url,
                    desktop: { width: 608, height: 342 },
                    tablet: { width: 487, height: 345 },
                    mobile: { width: 720, height: 404 },
                }"
                [priority]="isFirstView()"
                [alt]="image().alt ?? ''"
                cover
            />
        </div>
        <div class="flex flex-col items-start justify-center px-12 pt-16 pb-24 md:p-56">
            @let headlineWithFootnote = headline() | footnotes;
            <h3 class="text-34 break-word leading-41 text-black md:mb-8" [innerHTML]="headlineWithFootnote()"></h3>

            @if (text()) {
                @let pTextWithFootnote = (readMore() ? description() : text()) ?? '' | footnotes;
                <p class="text-16 leading-27 text-black" [innerHTML]="pTextWithFootnote()"></p>
            }
            @if (text() && description() && readLessText() && readMoreText()) {
                <button
                    class="text-16 leading-27 text-black underline"
                    (click)="readMore.set(!readMore())"
                    (mouseover)="imageCSS.set('image-hover-static')"
                    (mouseleave)="imageCSS.set('image-hover-static-animation')"
                >
                    {{ readMore() ? readLessText() : readMoreText() }}
                </button>
            }
            @if (link() && linkText()) {
                <div class="mt-24 flex w-full justify-end md:mt-16">
                    <a
                        ui-m010-c020-icon-link
                        [hyundaiRouterLink]="link()"
                        [queryParams]="queryParams()"
                        [fragment]="fragment()"
                        [trackingElTarget]="linkTrackingTarget()"
                        (mouseover)="imageCSS.set('image-hover-static')"
                        (mouseleave)="imageCSS.set('image-hover-static-animation')"
                        tracking
                        trackingEvent="engagement_click"
                        trackingElType="basic link"
                        trackingElLabel="Service Request"
                    >
                        {{ linkText() }}
                    </a>
                </div>
            }
        </div>
    </div>
</div>
